export default {
    tabTitles: {
        ai: 'AI',
        aiTooltip: 'The results are generated by artificial intelligence and are primarily used for inspiration. We recommend an individual assessment of the relevance and plausibility of these trends.',
        create: 'Create Use Case',
        edit: 'Edit Use Case',
        savedUseCases: 'Use Case Collection'
    },
    aiExplanation: {
        editButton: 'edit',
        saveButton: 'save',
        controls: {
            industrySelect: {
                pre: 'What could a potential use case look like in the',
                placeholder: 'please select/enter',
                selectHeader: 'please select or use input field',
                post: 'industry?'
            }
        }
    },
    form: {
        title: {
            label: 'Title',
            validationErrors: {
                required: 'Please enter a title'
            }
        },
        text: {
            label: 'Text',
            validationErrors: {
                required: 'Please enter text'
            }
        },
        submitButton: 'save',
        createButton: 'create',
        cancelButton: 'cancel'
    },
    savedUseCases: {
        deleteConfirmationDialog: {
            title: 'Delete Use Case',
            content: 'Do you really want to delete this use case?',
            cancelButton: 'cancel',
            confirmButton: 'yes, delete use case'
        },
        metadataFormat: 'Created on {createdOn} by {author}',
        deleteButton: 'Delete Use Case',
        editButton: 'Edit Use Case'
    }
}
